import { FC } from 'react';

import { ProfileStripeSectionProps } from './ProfileStripeSection.props';

import useConnectToStripeMutation from 'api/mutations/useConnectToStripeMutation';
import { getStripeDashboardUrl } from 'api/services/stripe';
import { $stripe } from 'state/stores/stripe';
import { $user } from 'state/stores/user';
import ProfileStripeSectionView from './ProfileStripeSection.view';

const ProfileStripeSectionContainer: FC<ProfileStripeSectionProps> = (
  props,
) => {
  const stripeId = $user.selectors.useStripeId();
  const isFetchingStripeStatus = $stripe.selectors.useIsFetchingData();
  const isConnectedToStripe = $stripe.selectors.useIsDetailsSubmitted();
  const isAccountEnabled = $stripe.selectors.useIsAccountEnabled();

  const { mutate: connectStripeAccount, isPending } =
    useConnectToStripeMutation(stripeId!);

  const openStripeDashboard = async () => {
    if (!stripeId) return;
    const dashboardUrl = await getStripeDashboardUrl(stripeId!);
    window.open(dashboardUrl, '_self');
  };

  return (
    <ProfileStripeSectionView
      isFetching={isFetchingStripeStatus}
      isConnected={isConnectedToStripe}
      isAccountEnabled={isAccountEnabled}
      onClickConnect={connectStripeAccount}
      onClickChangeInformation={openStripeDashboard}
    />
  );
};

export default ProfileStripeSectionContainer;
